import React from "react";

const Progress_bar = ({ bgcolor, progress, progressContent, height }) => {
  const Parentdiv = {
    height: height,
    width: "100%",
    backgroundColor: "#e9ecef",
    borderRadius: 40,
  };

  const Childdiv = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: bgcolor,
    borderRadius: 40,
    textAlign: "right",
  };

  const progresstext = {
    padding: 10,
    color: "darkslategrey",
    fontWeight: 900,
  };

  return (
    <div style={Parentdiv}>
      <div style={Childdiv}>
        <span style={progresstext}>{progressContent}</span>
      </div>
    </div>
  );
};

export default Progress_bar;
